/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {
	ButtonLayout,
	ButtonPrimary,
	Grid,
	GridItem,
	IconDisableLight,
	Text3,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";
import React, { useCallback } from "react";
import { useGlobalStore } from "../../contexts/globalStoreContext";
import { strings } from "../../localization";
import { FeedbackContainer, ScreenResponsive } from "../../components";
import { observer } from "mobx-react-lite";
import { useAnalytics } from "../../hooks/useAnalytics";
import { useNavigateCustom } from "../../hooks";

const AccessBlocked: React.FC = observer(() => {
	const navigation = useNavigateCustom();
	const { authenticationStore } = useGlobalStore();
	const { isDesktopOrBigger } = useScreenSize();
	const { updatePageView, addAnalyticEvent } = useAnalytics();

	const { description, title } = strings.pages.accessBlocked;
	const { toGoOut } = strings.components.buttons;

	React.useEffect(() => {
		updatePageView({ name: "Vivo Money FGTS Acesso Bloqueado", pagePath: "/fgts/acesso-bloqueado" });
		addAnalyticEvent({ event: "non_interaction",  action: "view-error", step: "fgts:acesso-bloqueado", description: title }, { applySanitize: true});
	}, []);

	// Efetua o logout na aplicação
	const onHandleToGoOut = useCallback(() => {
		addAnalyticEvent({ action: "click.button", step: "fgts:acesso-bloqueado", description: toGoOut }, { applySanitize: true});
		authenticationStore.logout();
		navigation("/login");
	}, []);

	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<GridItem>
					<FeedbackContainer
						icon={<IconDisableLight size={64} color={skinVars.colors.controlError} />}
						title={title}
						description={description}
					>
						<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
							<ButtonPrimary onPress={onHandleToGoOut} style={{ width: isDesktopOrBigger ? "auto" : "100%" }}>
								<Text3 medium color={skinVars.colors.textButtonPrimary}>
									{toGoOut}
								</Text3>
							</ButtonPrimary>
						</ButtonLayout>
					</FeedbackContainer>
				</GridItem>
			</Grid>
		</ScreenResponsive>
	);
});

export default AccessBlocked;
